export default {
    attribute:{
        bgColor:'#000',bgAlpha:0.0,modeUrl:'',
        ambientLightColor:'#222',pointLightColor:'#fff',pointLightX:20,pointLightY:40,pointLightZ:10,
        animateIndex:0,
    },
    interaction:{intType: 'none'}
}